export const ELIGIBILITY = {
    value: "ELIGIBILITY",
    key: "clients.form.additionalConfigurations.eligibility"
};
export const NO_SYNC = {
    value: "NO_SYNC",
    key: "clients.form.additionalConfigurations.noSync"
};
export const TED_DESJARDINS = {
    value: "TED_DESJARDINS",
    key: "clients.form.additionalConfigurations.tedDesjardins"
};

export default [ELIGIBILITY, NO_SYNC, TED_DESJARDINS];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/synchronizationOptions.js